import { CircleNotchIcon } from '@phosphor-icons/react'
import React from 'react'

import * as S from './button.styled'

interface VisitorParkingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  loading?: boolean
}

export const Button = ({ children, loading, disabled, ...props }: VisitorParkingButtonProps) => {
  return (
    <S.StyledButton disabled={disabled || loading} {...props}>
      {loading ? <S.SpinnerIcon icon={CircleNotchIcon} size="2.4rem" /> : children}
    </S.StyledButton>
  )
}
